export const formatHoursMinutes = (hours: number): string => {
  const totalMinutes = Math.round(hours * 60);
  const totalHours = Math.floor(totalMinutes / 60);
  const totalDays = Math.floor(totalHours / 24);
  const monthsPart = Math.floor(totalDays / 30);
  const weeksPart = Math.floor((totalDays % 30) / 7);
  const daysPart = totalDays % 7;
  const hoursPart = totalHours % 24;
  const minutesPart = totalMinutes % 60;
  if (monthsPart > 0) {
    const parts = [`${monthsPart}mo`];
    if (weeksPart > 0) parts.push(`${weeksPart}w`);
    if (daysPart > 0) parts.push(`${daysPart}d`);
    return parts.slice(0, 2).join(' ');
  }
  if (weeksPart > 0) {
    const parts = [`${weeksPart}w`];
    if (daysPart > 0) parts.push(`${daysPart}d`);
    if (hoursPart > 0) parts.push(`${hoursPart}h`);
    return parts.slice(0, 2).join(' ');
  }
  if (daysPart > 0) {
    const parts = [`${daysPart}d`];
    if (hoursPart > 0) parts.push(`${hoursPart}h`);
    if (minutesPart > 0) parts.push(`${minutesPart}m`);
    return parts.slice(0, 2).join(' ');
  }
  if (hoursPart <= 0) return `${minutesPart}m`;
  if (minutesPart <= 0) return `${hoursPart}h`;
  return `${hoursPart}h ${minutesPart}m`;
};

export const formatGreenTime = (days: number): string => {
  const totalMinutes = Math.round(days * 24 * 60);
  if (totalMinutes <= 0) return '0m';
  if (totalMinutes < 60) return `${totalMinutes}m`;
  const totalHours = Math.round(totalMinutes / 60);
  if (totalHours % 24 === 0) return `${totalHours / 24}d`;
  return `${totalHours}h`;
};

export const formatSeconds = (value: number): string => `${Math.round(value)}s`;
